module.exports = __webpack_public_path__ + "img/ring_skip_skip_0_1.2dfeffdf.png";